var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSovoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.5 70.8",
    style: {
      enableBackground: "new 0 0 171.5 70.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{clip-path:url(#SVGID_00000102518436599353068760000012033361279023052445_);fill:#FFFFFF;} .st1{clip-path:url(#SVGID_00000163037749599539609190000010653387352734281648_);fill:#FFFFFF;} .st2{clip-path:url(#SVGID_00000023986864020105813080000000802759486666543807_);fill:#780000;} .st3{clip-path:url(#SVGID_00000023986864020105813080000000802759486666543807_);fill:#FFFFFF;} .st4{fill:#FFFFFF;} .st5{fill:#780000;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.8,35.6c0,2-0.5,3.7-1.5,5.3c-1,1.6-2.5,2.8-4.4,3.8c-1.9,0.9-4.1,1.4-6.7,1.4c-2.4,0-4.8-0.5-7.1-1.5 c-2.3-1-4-2.5-5-4.5l0.6-0.9c1,1.9,2.6,3.3,4.8,4.3c2.2,1,4.4,1.5,6.7,1.5c2.5,0,4.4-0.6,5.8-1.7c1.4-1.2,2.1-2.8,2.1-4.9 c0-1.6-0.7-3.1-2.2-4.4c-1.5-1.3-3.7-2.6-6.9-3.9c-2.7-1.2-4.8-2.2-6.4-3.1c-1.5-0.9-2.7-1.9-3.5-3.1C9.4,22.8,9,21.4,9,19.8 c0-2.1,0.6-3.9,1.7-5.4c1.1-1.5,2.6-2.6,4.4-3.4c1.8-0.8,3.8-1.2,6-1.2c2.5,0,4.8,0.6,6.9,1.7c2.2,1.1,3.7,2.6,4.7,4.6L32,16.9 c-0.9-1.9-2.4-3.3-4.4-4.4c-2.1-1.1-4.2-1.6-6.3-1.6c-2.5,0-4.5,0.5-6,1.5c-1.4,1-2.2,2.5-2.2,4.4c0,1.1,0.3,2.1,1,2.9 c0.7,0.8,1.6,1.5,2.7,2.1c1.1,0.6,2.8,1.4,5.1,2.5l1.6,0.8c3.5,1.6,6.1,3.2,7.8,4.7C33,31.4,33.8,33.3,33.8,35.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.5,27.9c0,3.3-0.8,6.3-2.4,9c-1.6,2.8-3.8,5-6.6,6.6c-2.8,1.6-5.8,2.5-9,2.5c-3.3,0-6.3-0.8-9-2.4 c-2.8-1.6-5-3.8-6.6-6.6c-1.6-2.8-2.4-5.8-2.4-9.1c0-3.3,0.8-6.3,2.4-9.1c1.6-2.8,3.8-5,6.6-6.6c2.8-1.6,5.8-2.4,9-2.4 c3.2,0,6.3,0.8,9,2.5c2.8,1.6,5,3.9,6.6,6.6C77.7,21.7,78.5,24.7,78.5,27.9z M72.1,27.9c0-4.3-0.5-7.5-1.5-9.7 c-1-2.2-2.3-4-4.1-5.3c-1.7-1.3-3.8-2-6.1-2c-2.3,0-4.4,0.7-6.1,2c-1.8,1.4-3.2,3.2-4.1,5.3c-1,2.2-1.4,5.4-1.4,9.7 c0,4.3,0.5,7.5,1.4,9.7c1,2.2,2.3,4,4.1,5.3c1.7,1.3,3.8,2,6.1,2c2.3,0,4.3-0.7,6.1-2c1.8-1.4,3.1-3.2,4.1-5.3 C71.7,35.5,72.1,32.2,72.1,27.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.1,46.1l-15.7-36h6.7L105,37.3l12.5-27.2h1.2L102.1,46.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.5,27.9c0,3.3-0.8,6.3-2.4,9c-1.6,2.8-3.8,5-6.6,6.6c-2.8,1.6-5.8,2.5-9,2.5s-6.3-0.8-9-2.4 s-5-3.8-6.6-6.6c-1.6-2.8-2.4-5.8-2.4-9.1c0-3.3,0.8-6.3,2.4-9.1c1.6-2.8,3.8-5,6.6-6.6s5.8-2.4,9-2.4s6.3,0.8,9,2.5 c2.8,1.6,5,3.9,6.6,6.6C161.7,21.7,162.5,24.7,162.5,27.9z M156.2,27.9c0-4.3-0.5-7.5-1.5-9.7c-1-2.2-2.3-4-4.1-5.3 c-1.7-1.3-3.8-2-6.1-2c-2.3,0-4.4,0.7-6.1,2c-1.8,1.4-3.2,3.2-4.1,5.3c-1,2.2-1.4,5.4-1.4,9.7c0,4.3,0.5,7.5,1.4,9.7 c1,2.2,2.3,4,4.1,5.3c1.7,1.3,3.8,2,6.1,2c2.3,0,4.3-0.7,6.1-2c1.8-1.4,3.1-3.2,4.1-5.3C155.7,35.5,156.2,32.2,156.2,27.9z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "66.3,58.6 8.9,58.6 8.9,59.7 70.4,59.7 70.4,58.6 66.3,58.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.2,60v-4.2h0.8c1.1,0,2,0.9,2,2.1c0,1.2-0.9,2.1-2,2.1H76.2z M75.3,61h1.8c1.7,0,3-1.3,3-3s-1.3-3-3-3h-1.8 V61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "87.5,55.8 87.5,55 84.1,55 84.1,61 87.5,61 87.5,60.1 85.1,60.1 85.1,58.4 87.2,58.4 87.2,57.5 85.1,57.5 85.1,55.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.2,55 93.6,59.7 91.9,55 90.8,55 93,61 94.1,61 96.3,55 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "103.2,55.8 103.2,55 99.8,55 99.8,61 103.2,61 103.2,60.1 100.8,60.1 100.8,58.4 102.9,58.4 102.9,57.5 100.8,57.5 100.8,55.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "108.3,60 108.3,55 107.3,55 107.3,61 110.4,61 110.4,60 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.8,60.1c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1c1.2,0,2.1,0.9,2.1,2.1S118,60.1,116.8,60.1z M116.8,61 c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1C113.7,59.7,115.1,61,116.8,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M126.1,57.6h-1.2v-1.7h1.2c0.5,0,0.9,0.3,0.9,0.9C127,57.2,126.6,57.6,126.1,57.6z M126.2,55h-2.4v6h1v-2.6 h1.4c1,0,1.7-0.7,1.7-1.7C127.9,55.7,127.2,55,126.2,55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "136.8,55 134.7,59.7 132.6,55 131.6,55 131.6,61 132.6,61 132.6,56.8 134.4,61 135,61 136.9,56.8 136.9,61 137.9,61 137.9,55 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "145.6,55.8 145.6,55 142.1,55 142.1,61 145.6,61 145.6,60.1 143.1,60.1 143.1,58.4 145.2,58.4 145.2,57.5 143.1,57.5 143.1,55.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "153.9,55 153.9,59.4 150.6,55 149.6,55 149.6,61 150.6,61 150.6,56.5 153.9,61 154.9,61 154.9,55 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "162.6,55 158.5,55 158.5,55.9 160,55.9 160,61 161,61 161,55.9 162.6,55.9 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovoLogo);
export default __webpack_public_path__ + "static/media/sovo-logo.de2cd212427aa6915e54ada28c223cf4.svg";
export { ForwardRef as ReactComponent };